import React from 'react';
import { useProgress } from '../hooks/useProgress';

const LessonCard = ({ lesson }) => {
  const { isLessonCompleted, completeLesson, setLastVisited } = useProgress();
  const completed = isLessonCompleted(lesson.id);
  
  const handleClick = () => {
    setLastVisited(lesson.id);
  };
  
  const handleMarkComplete = (e) => {
    e.stopPropagation();
    completeLesson(lesson.id);
  };
  
  return (
    <div className={`lesson-card ${completed ? 'completed' : ''}`}>
      <div className="lesson-number">Lesson {lesson.id}</div>
      <h3 className="lesson-title">{lesson.title}</h3>
      <p className="lesson-description">{lesson.description}</p>
      <div className="lesson-actions">
        <button 
          className="btn-primary" 
          onClick={handleClick}
        >
          View Lesson
        </button>
        {!completed && (
          <button 
            className="btn-secondary" 
            onClick={handleMarkComplete}
          >
            Mark Complete
          </button>
        )}
        {completed && (
          <span className="completion-badge">
            <svg viewBox="0 0 24 24" width="16" height="16">
              <path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
            </svg>
            Completed
          </span>
        )}
      </div>
    </div>
  );
};

export default LessonCard;
